// Centralized SEO constants for the OOPBuy Spreadsheet site
// Uses VITE_SITE_URL env var for the real site origin

export const SITE_URL: string =
  typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL
    ? (import.meta.env.VITE_SITE_URL as string)
    : 'https://oopbuyspread.homes';

export const SITE_NAME = 'OOPBuy Spreadsheet Deutschland';
export const SITE_DESCRIPTION =
  'Entdecke das beste OOPBuy Spreadsheet 2026. Produktlisten, QC Bilder, Taobao, Weidian, 1688 Guides, Versandtipps und sichere Einkaufshilfe für Deutschland.';
export const SITE_LOGO =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg';
export const SITE_LOCALE = 'de_DE';